export const styles = {
  alert: {
    fontFamily: "Roboto",
    fontSize: 18,
    color: "white.main",
  },
};
